import { render, staticRenderFns } from "./addEffect.vue?vue&type=template&id=3c35e4f8&scoped=true"
import script from "./addEffect.vue?vue&type=script&lang=js"
export * from "./addEffect.vue?vue&type=script&lang=js"
import style0 from "./addEffect.vue?vue&type=style&index=0&id=3c35e4f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c35e4f8",
  null
  
)

export default component.exports